import {
  assignOrder,
  car,
  getStatus,
  getCarOrder,
  depot
} from '@/api/oli_api'

import {
  outPutExcelFile,
  dateOperating
} from '@/cllib'
// 运单分配

let oilType = {
  '0': '60205886',
  '92': '60206059',
  '95': '60206060',
  '98': '60209058'
}

const state = {
  orderCar: [],
  orderGas: [],
  canChooseCars: [],
  orderTj: []
}

const getters = {
  orderCar: state => state.orderCar,
  orderGas: state => state.orderGas,
  canChooseCars: state => state.canChooseCars,
  orderTj: state => state.orderTj
}

export let getTime = function (order, num) {
  num = num || 7000
  let heNum = 0
  JSON.parse(order[8]).forEach(function (item) {
    heNum += item
  })
  let hour = (heNum - order[5]) / num
  let day = hour > 0 ? (hour > 23 ? '15' : '14') : '13'
  if (hour < 0) {
    hour = 24 + hour
  }
  let hourNum = parseInt(hour)
  let min = (hour - hourNum) * 60
  let minNum = parseInt(min)
  return '09-' + day + ' ' + ((hourNum % 24) < 10 ? ('0' + (hourNum % 24)) : (hourNum % 24)) + ':' + (minNum < 10 ? ('0' + minNum) : minNum)
}

const actions = {
  getAssignStatus ({ dispatch }) {
    setTimeout(function () {
      getStatus({key: 'assign_order'}).then(function (data) {
        let inputStatus = Number(data.data)
        if (inputStatus === 1) {
          dispatch('getAssignStatus')
        } else if (inputStatus === 0) {
          dispatch('assignCarOrder2')
        } else if (inputStatus === -1) {
          dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '订单分配失败，请联系管理员！'
          })
          dispatch('setPercentage', {'start': 100, 'next': 100})
        }
      })
    }, 5000)
  },
  assignCarOrder ({ dispatch, getters }, data) {
    if (data) {
      dispatch('setLoading', true)
      dispatch('setLoadingText', '匹配车辆中')
      dispatch('setPercentage', {'start': 0, 'next': 100})
    }
    dispatch('assignCarOrder2', data)
  },
  assignCarOrder2 ({ dispatch, getters }, data) {
    assignOrder({'sys_pipei': data ? 1 : 0}).then((data) => {
      if (data.msg === 'jx') {
        dispatch('getAssignStatus')
        return
      }
      if (data.msg === 'nocar') {
        dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '无可用车辆，请先签到！'
        })
        dispatch('setPercentage', {'start': 100, 'next': 100})
        return
      }
      let stations = []
      let cars = []
      data.forEach(function (item) {
        item['在途时间'] = Number(item['在途时间']).toFixed(2)
        stations.push(item)
        cars.push(item)
      })
      dispatch('setOrderGas', stations)
      dispatch('setOrderCar', cars)
      dispatch('setFlowStatus', 40)
      dispatch('setLoadingText', '匹配车辆完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }).catch((e) => {
      console.log(e)
      dispatch('setPercentage', {'start': 100, 'next': 100})
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '订单分配失败，请联系管理员！'
      })
    })
  },
  outputPsDatas ({ getters, dispatch }, data) {
    let datas = [{
      data: [],
      sheetName: 'data1'
    }]
    let row1 = ['配送日期', '车牌号', '隔仓号', '到站代码', '到站名称', '罐号', '油品代码', '油品名称', '升数 （升）', '数量（公斤）', '油库代码', '油库名称', '趟', '次', '班次', '驾驶员代码', '驾驶员姓名', '送达时间', '进销货标识', '配送类型', '进货类型']
    datas[0].data.push(row1)
    getters.orderCar.forEach(function (item) {
      let need = false
      data.oilType.forEach((itemOilType) => {
        if (item['油品名称'].includes(itemOilType)) {
          need = true
        }
      })
      if (need) {
        let psDate = item['预计发车时间'] ? item['时间'].slice(0, 5) + item['预计发车时间'].slice(0, 5) : dateOperating.computeDay({date: new Date(), days: 1, format: 'yy-mm-dd'})
        psDate = psDate.split('-')[0] + '/' + Number(psDate.split('-')[1]) + '/' + Number(psDate.split('-')[2])
        let gch = item['隔仓号'] || 1
        let ypdm = oilType[item['油品名称'].split('号')[0]] || ''
        let tang = item['趟次'] || 1
        datas[0].data.push([psDate, item['车牌号'], gch, item['油站代码'], item['加油站名称'], item['罐号'], ypdm, item['油品名称'], item['配送升数'], '', item['油库代码'], item['油库名称'], tang, 1, 1, '66', '', psDate, '', '', ''])
      }
    })
    outPutExcelFile(datas, '每日订单' + getters.todayStr + '.xls')
    if (data.clear) {
      dispatch('setOrderCar', [])
    }
  },
  getOrderCars ({ dispatch, getters }) {
    dispatch('setOrderCar', [])
    getCarOrder().then((data) => {
      if (!data || data.length === 0) {
        dispatch('showNoticeMsg', {
          type: 'info',
          title: '系统提示',
          message: '无配送单！'
        })
        return
      }
      let allData = []
      data.forEach(function (item) {
        item['在途时间'] = Number(item['在途时间']).toFixed(2)
        allData.push(item)
      })
      dispatch('setOrderCar', allData)
    }).catch((e) => {
      console.log(e)
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '获取配送单失败，请联系管理员！'
      })
    })
  },
  getTjData ({ dispatch, getters }, data) {
    dispatch('setOrderTj', [])
    let parm = {
      action: 'get_depot_pstj',
      data: data
    }
    depot(parm).then((data) => {
      dispatch('setOrderTj', data || [])
    }).catch((e) => {
      console.log(e)
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '获取配送单失败，请联系管理员！'
      })
    })
  },
  loadCanChooseCars ({ dispatch }, data) {
    let parm = {
      action: 'get_cars',
      data: {
        '配送中心': '昆配',
        '车辆轴数': ''
      }
    }
    car(parm).then((data) => {
      let newData = []
      data.forEach(function (item) {
        let changeed = Number(item['更改油品']) === 1
        let oneData = ['昆明', item['车牌号'], Number(changeed ? item['合计_G'] : item['合计']) || '', 0, Number(item['前仓']) || '', Number(changeed ? item['中仓_G'] : item['中仓']) || '', Number(changeed ? item['后仓_G'] : item['后仓']) || '', '']
        oneData[3] = (oneData[4] ? 1 : 0) + (oneData[5] ? 1 : 0) + (oneData[6] ? 1 : 0)
        newData.push(oneData)
      })
      dispatch('setCanChooseCars', newData)
    })
  },
  setOrderTj ({ commit }, data) {
    commit('setOrderTj', data)
  },
  setOrderCar ({ commit }, data) {
    let newData = []
    let cars = {}
    data.forEach((item) => {
      cars[item['车牌号']] = cars[item['车牌号']] || []
      cars[item['车牌号']].push(item)
    })
    for (let key in cars) {
      cars[key].forEach((item) => {
        newData.push(item)
      })
    }
    commit('setOrderCar', newData)
  },
  setOrderGas ({ commit, getters, dispatch }, data) {
    let newData = []
    let day = getters.todayStr
    let newData2 = []
    data.forEach(function (item) {
      let oilName = item['加油站名称']
      let itemDay = item['时间']
      if (itemDay === day) {
        newData2.push(item)
        let allGasLocation = getters.gasLocation
        let stationName = allGasLocation[oilName] ? allGasLocation[oilName][2] : ''
        if (stationName !== '' && stationName !== '') {
          let allDepotLocation = getters.depotLocation
          let oilLocation = allGasLocation[oilName] ? [allGasLocation[oilName][0], allGasLocation[oilName][1]] : []
          let stationLocation = allDepotLocation[allGasLocation[oilName][2]] ? [...allDepotLocation[allGasLocation[oilName][2]]] : []
          if (oilLocation.length > 0 && stationLocation.length > 0) {
            newData.push({
              name: item['油库名称'],
              data: [{
                fromName: stationName,
                toName: oilName,
                coords: [stationLocation, oilLocation],
                info: item
              }]
            })
          } else {
            console.log(stationName)
          }
        }
      }
    })
    dispatch('setAllMapOneRoute', newData)
    commit('setOrderGas', data)
  },
  editOrderCar ({ commit }, data) {
    // 修改订单车辆
    commit('editOrderCar', data)
  },
  editOrderDepot ({ commit }, data) {
    // 修改订单油库
    commit('editOrderDepot', data)
  },
  setCanChooseCars ({ commit }, data) {
    commit('setCanChooseCars', data)
  }
}

const mutations = {
  editOrderDepot (state, {index, station}) {
    let order = state.orderGas[index]
    order['油库名称'] = station
    let data = []
    state.orderGas.forEach(function (item) {
      data.push(item)
    })
    state.orderGas = data
  },
  editOrderCar (state, {index, carId}) {
    let order = state.orderGas[index]
    order['车牌号'] = carId
    let data = []
    state.orderGas.forEach(function (item) {
      data.push(item)
    })
    state.orderGas = data
  },
  setOrderTj (state, data) {
    state.orderTj = data
  },
  setCanChooseCars (state, data) {
    state.canChooseCars = data
  },
  setOrderCar (state, data) {
    state.orderCar = data
  },
  setOrderGas (state, data) {
    state.orderGas = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/prediction_order.js